import { m } from "framer-motion";

const GOLD = "var(--labrador-yellow)";
const goldToward = (color: string, amount: number) =>
    `color-mix(in oklab, ${GOLD}, ${color} ${amount}%)`;

const METAL_STOPS = [
    { offset: "0%", color: goldToward("var(--true-white)", 55) },
    { offset: "30%", color: goldToward("var(--true-white)", 25) },
    { offset: "50%", color: GOLD },
    { offset: "70%", color: goldToward("var(--chocolate-lab)", 6) },
    { offset: "100%", color: goldToward("var(--chocolate-lab)", 16) },
];
export const EDGE = goldToward("var(--chocolate-lab)", 40);
export const BURN =
    "color-mix(in oklab, var(--chocolate-lab), var(--doberman-black) 55%)";

export const goldRef = (id: string, name: string) => `${id}-${name}`;
export const goldUrl = (id: string, name: string) =>
    `url(#${goldRef(id, name)})`;

export function GoldMetalDefs({
    id,
    path,
    gradient,
    shadow,
}: {
    id: string;
    path: string;
    gradient: { y1: number; y2: number };
    shadow: {
        x: string;
        y: string;
        width: string;
        height: string;
        dy: number;
        blur: number;
        opacity: number;
    };
}) {
    return (
        <defs>
            <linearGradient
                id={goldRef(id, "metal")}
                x1="0"
                y1={gradient.y1}
                x2="0"
                y2={gradient.y2}
                gradientUnits="userSpaceOnUse"
            >
                {METAL_STOPS.map((stop) => (
                    <stop
                        key={stop.offset}
                        offset={stop.offset}
                        stopColor={stop.color}
                    />
                ))}
            </linearGradient>
            <linearGradient
                id={goldRef(id, "sheen")}
                x1="0"
                x2="1"
                y1="0"
                y2="0"
            >
                <stop
                    offset="0"
                    stopColor="var(--true-white)"
                    stopOpacity="0"
                />
                <stop
                    offset="0.5"
                    stopColor="var(--true-white)"
                    stopOpacity="0.8"
                />
                <stop
                    offset="1"
                    stopColor="var(--true-white)"
                    stopOpacity="0"
                />
            </linearGradient>
            <clipPath id={goldRef(id, "clip")}>
                <path d={path} />
            </clipPath>
            <filter
                id={goldRef(id, "shadow")}
                x={shadow.x}
                y={shadow.y}
                width={shadow.width}
                height={shadow.height}
            >
                <feDropShadow
                    dx="0"
                    dy={shadow.dy}
                    stdDeviation={shadow.blur}
                    floodColor="var(--doberman-black)"
                    floodOpacity={shadow.opacity}
                />
            </filter>
        </defs>
    );
}

export function GoldSheen({
    id,
    width,
    height,
    from,
    to,
}: {
    id: string;
    width: number;
    height: number;
    from: number;
    to: number;
}) {
    return (
        <g clipPath={goldUrl(id, "clip")}>
            <g transform="skewX(-20)">
                <m.rect
                    y="0"
                    width={width}
                    height={height}
                    fill={goldUrl(id, "sheen")}
                    initial={{ x: from }}
                    animate={{ x: to }}
                    transition={{
                        delay: 0.7,
                        duration: 1,
                        ease: [0.4, 0, 0.2, 1],
                    }}
                />
            </g>
        </g>
    );
}
